// extracted by mini-css-extract-plugin
export default {"comments":"CommentsList_comments__jhrQH","title":"CommentsList_title__21D78"};